import { useOktaAuth } from '@okta/okta-react';
import { useState, useEffect ,useMemo} from 'react';

export function useAuthUser() {
  const [user, setUser] = useState('');
  const [rawGroups, setRawGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const { authState, oktaAuth } = useOktaAuth();

  // check that oktaAuth is defined
  const setUserInfo = (userData, userGroups) => {
    setUser(userData);
    setRawGroups(userGroups);
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!authState?.isAuthenticated) {
        setLoading(false);
        return;
      }

      if (!oktaAuth?.tokenManager?.get || !oktaAuth?.getUser) {
        console.warn("oktaAuth not fully initialized");
        setLoading(false);
        return;
      }

    try {
      const accessToken = await oktaAuth.tokenManager.get('accessToken');
      const claims = accessToken?.claims || {};
      const env = process.env.REACT_APP_MODE; // e.g., "uat"
      const groupKey = `groups_cuckoo_${env}`;
      const userGroups = claims[groupKey] || [];

      const userInfo = await oktaAuth.getUser();
      setUser(userInfo);
      setRawGroups(userGroups);
    } catch (error) {
      console.error('Error fetching user info:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchUserInfo();
}, [authState, oktaAuth]);

  // Memoize groups for efficiency
  const groups = useMemo(() => rawGroups, [rawGroups]);

  return {
    user,
    groups,
    loading,
    setUserInfo,
  };
}
